import request from '@/services/helpers/request';
import { API_ROUTES } from '@/config';

export const getHeader = async params => (await request.getInstance()).get(API_ROUTES.statsFormation.getHeader + params);
export const getStats = async params => (await request.getInstance()).get(API_ROUTES.statsFormation.getStats + params);
export const getResponses = async params => (await request.getInstance()).get(API_ROUTES.statsFormation.getResponses + params);
export const getCandidates = async params => (await request.getInstance()).get(API_ROUTES.statsFormation.getCandidates + params);
export const getProfessions = async params => (await request.getInstance()).get(API_ROUTES.statsFormation.getProfessions + params);
